import React from 'react'
import ProfileButton from '../../../forms/profileButton';
import {ReactComponent as SettingIcon} from '../../../../images/admin/sidebar/setting.svg'
import {ReactComponent as BackIcon} from '../../../../images/admin/sidebar/back.svg'
import { Link } from 'react-router-dom';
import { useRef, useState } from 'react';
import { QRCodeCanvas } from "qrcode.react";
import ApiUrl from '../../../../configTools/apiUrl';

const Top = ({Values,Refresh,User,FollowerOpen,FollowingOpen}) => {
    const popupBox = useRef(null);
    const popupBoxContainer = useRef(null);
    const [qr,setQR] = useState(0);
    const qrcode = (
        <QRCodeCanvas
          id="qrCode"
          value={window.location.href}
          bgColor={"#ffffff"}
          level={"H"}
          size={400}
        />
    );
    const Stars = ({count,reviews}) => (
        <p style={{textAlign:"center"}}>
            {
                Array.from({length: count}).map((_item, index) => {
                    return(
                        <b key={index} className='colored'>★</b>
                    )
                })
            }
            {
                Array.from({length: 5-count}).map((_item, index) => {
                    return(
                        <b key={index} className='empty'>☆</b>
                    )
                })
            }
            {
                "("+reviews+")"
            }
        </p>
    )
    const change_follow = ()=>{
        fetch(ApiUrl.API_URL_Follower, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
                followtoid : Values.id
            })
          })
          .then(res=>res.json())
          .then(data =>{
            Refresh();
        });
    }
    const showPreview = (e) =>{
        if(e.target.files && e.target.files[0]){
            let imageFile = e.target.files[0];
            const formData = new FormData();
            formData.append("file",imageFile);
            fetch(ApiUrl.API_URL_File, {
                method: 'POST',
                body: formData
            })
            .then(res=>res.json())
            .then(data =>{
                if(data.success){
                    fetch(ApiUrl.API_URL_Profile, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer '+User.token
                        },
                        body: JSON.stringify({
                            Id:User.id,
                            discription: Values.discription,
                            firstname : Values.firstname,
                            lastname : Values.lastname,
                            address : Values.address,
                            cnic : Values.cnic,
                            contact : Values.contact,
                            email : Values.email,
                            location : Values.location,
                            image : data.url
                        })
                      })
                      .then(res2=>res2.json())
                      .then(data2 =>{
                        if(data2.success){
                            let userNew = User;
                            userNew.image = data.url;
                            localStorage.setItem("user-info",JSON.stringify(userNew));
                            document.location.reload();
                        }
                        else{
                            console.log(data2.responce);
                        }
                    });

                }
                else{
                    console.log(data.responce);
                }
            });
        }
    }
    const showPopUp = () =>{
        popupBox.current.className = 'active top_settings_popup';
        setTimeout(() => {
            popupBoxContainer.current.className = 'active top_settings_popup_container';
        }, 20);
    }
    const hidePopUp = () =>{
        popupBox.current.className = 'top_settings_popup'
        popupBoxContainer.current.className = 'top_settings_popup_container'
    }
    const SignOut = () =>{
        localStorage.removeItem('user-info');
        document.location.reload();
    }
    return(
        <div className='top_profile_container'>
            <div className='top_profile_row'>
                <div className='top_profile_image'>
                    {User && User.username === Values.username &&
                        <label style={{cursor:"pointer"}}>
                            <div style={{
                                width: "100%",
                                paddingTop: "100%",
                                borderRadius: "50%",
                                position: "relative",
                                backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Values.image})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                marginBottom:"20px"
                                
                            }}>
                            <input type="file" style={{display:"none"}} onChange={showPreview}/>
                            </div>
                        </label>
                    }
                    {User && User.username !== Values.username &&
                        <label style={{cursor:"pointer"}}>
                            <div style={{
                                width: "100%",
                                paddingTop: "100%",
                                borderRadius: "50%",
                                position: "relative",
                                backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Values.image})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                marginBottom:"20px"
                                
                            }}>
                            </div>
                        </label>
                    }
                    {!User &&
                        <label style={{cursor:"pointer"}}>
                            <div style={{
                                width: "100%",
                                paddingTop: "100%",
                                borderRadius: "50%",
                                position: "relative",
                                backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Values.image})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                marginBottom:"20px"
                                
                            }}>
                            </div>
                        </label>
                    }
                    <Stars count={Values.averagestars} reviews={Values.reviewcount}/>
                </div>
                <div style={{width:"10%"}}></div>
                <div className='top_profile_details'>
                    <div className='top_profile_details_top_container'>
                        <h3>{Values.firstname} {Values.lastname}</h3>
                        {User && User.username !== Values.username &&
                            <ProfileButton Value={Values.followingthis? "Unfollow": "Follow"} Action={change_follow} style={{cursor:"pointer"}}/>
                        }
                        {User && User.username === Values.username &&
                            <>
                                <Link to={'/dashboard/editprofile'}>
                                    <ProfileButton Value={"Edit Profile"}/>
                                </Link>
                                <div className='top_profile_details_top_settings'>
                                    <SettingIcon onClick={showPopUp}/>
                                </div>
                            </>
                        }
                        {!User &&
                            <Link to={'/login'}>
                                <ProfileButton Value={"Follow"}/>
                            </Link>
                        }
                    </div>
                    <div className='top_profile_details_middle_container'>
                        <p><b>{Values.postcount}</b>Posts</p>
                        <p onClick={()=>{
                            if(User){
                                FollowerOpen();
                            }
                            }}><b>{Values.followers}</b>Followers</p>
                        <p onClick={()=>{
                            if(User){
                                FollowingOpen();
                            }
                            }}><b>{Values.following}</b>Following</p>
                    </div>
                    <div className='top_profile_details_bottom_container'>
                        <h5>{Values.username}</h5>
                        <p>{Values.discription}</p>
                    </div>
                </div>
            </div>
            <div className='top_settings_popup' ref={popupBox}>
                <div className='top_settings_popup_container' ref={popupBoxContainer}>
                    {qr === 0 &&
                        <>
                            <Link to='#'>
                                <div className='top_settings_popup_item'>
                                    <h5>Change Password</h5>
                                </div>
                            </Link>
                            <Link to='#'>
                                <div className='top_settings_popup_item' onClick={()=>{
                                        setQR(1)
                                    }}>
                                    <h5>QR Code</h5>
                                </div>
                            </Link>
                            <Link to='#' onClick={SignOut}>
                                <div className='top_settings_popup_item'>
                                    <h5>Log Out</h5>
                                </div>
                            </Link>
                            <Link to='#' onClick={hidePopUp}>
                                <div className='top_settings_popup_item'>
                                    <h5>Cancel</h5>
                                </div>
                            </Link>
                        </>
                    }
                    {qr === 1 &&
                        <div className='top_settings_popup_qr_container'>
                            <div className='top_settings_popup_qr_back_container'>
                                <div className='top_settings_popup_qr_back'>
                                    <BackIcon onClick={()=>{
                                        setQR(0)
                                    }}/>
                                </div>
                            </div>
                            <div className='top_settings_popup_qr'>{qrcode}</div>
                        </div>
                    }
                </div>
                <div className='top_settings_popup_closer' onClick={hidePopUp}></div>
            </div>
        </div>
    )
}

export default Top

